module.exports = __webpack_public_path__ + "img/38.588e343a.jpg";